import { Component, Injector, ElementRef } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseResourceFormComponent, Favorecido, LoginContabil,
  GlobalService, FavorecidoService
} from 'eddydata-lib';
import { LiquidacaoService } from '../../../contabil/liquidacao/service/liquidacao.service';
import { PagamentoService } from '../../../tesouraria/pagamento/service/pagamento.service';

@Component({
  selector: 'lib-favorecido-shw',
  templateUrl: './favorecido-shw.component.html'
})
export class FavorecidoShwComponent extends BaseResourceFormComponent<Favorecido, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  public dataBar: any;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected globalService: GlobalService,
    protected liquidacaoService: LiquidacaoService,
    protected pagamentoService: PagamentoService,
    protected favorecidoService: FavorecidoService) {
    super(new Favorecido(), injector, Favorecido.converteJson, favorecidoService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      cpf_cnpj: [null, [Validators.required]],
      nome: [null, [Validators.required]],
      nome_fantasia: [null, [Validators.required]],
      endereco: [null, [Validators.required]],
      bairro: [null, [Validators.required]],
      num_endereco: [null, [Validators.required]],
      municipio: [null, [Validators.required]],
      uf: [null, [Validators.required, Validators.minLength(2)]],
      ddd_fone: [null, [Validators.required]],
      telefone: [null, [Validators.required]],
      pis: [null, [Validators.required]],
      email: [null, [Validators.required]],
      tipo: [null, [Validators.required]],
      url: [null, [Validators.required]],
      autarquia: [null, [Validators.required]],
      autorizado: [null, [Validators.required]],
      servidor: [null, [Validators.required]],
      simples_nacional: [null, [Validators.required]],
      gasto_fixo: [null, [Validators.required]],
      cidade: this.fb.group({
        nome: [null, [Validators.required]]
      })
    });
  }

  protected parametrosExtras(): {} {
    return { relations: 'cidade' };
  }

  protected afterInit(): void {
  }

  protected campoFoco(): ElementRef {
    return null;
  }

  protected beforeSubmit(): void {
  }

  protected afterSubmit(entidade: Favorecido): void {
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  protected afterLoad() {
    this.graficoBar();
  }

  public async graficoBar() {
    const listLiquidado = await this.liquidacaoService.totalFavorecidoMes(this.login.exercicio.id, this.entidade.id).toPromise();
    const listPago = await this.pagamentoService.totalFavorecidoMes(this.login.exercicio.id, this.entidade.id).toPromise();
    const meses = [];
    const array1 = [];
    const array2 = [];
    for (const idx of listLiquidado) {
      array1.push(idx.total / 10000);
    }
    for (const idx of listPago) {
      meses.push(idx.mes);
      array2.push(idx.total / 10000);
    }

    this.dataBar = {
      labels: meses,
      datasets: [
        {
          label: 'Liquidado',
          backgroundColor: '#42A5F5',
          borderColor: '#1E88E5',
          data: array1
        },
        {
          label: 'Pago',
          backgroundColor: '#9CCC65',
          borderColor: '#7CB342',
          data: array2
        }
      ]
    };
  }

}
